'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var EventEmitter = require('events');

var pipe = require('it-pipe');

var emitter = new EventEmitter();

function handler(_ref) {
  var connection = _ref.connection,
      stream = _ref.stream;
  var peerId = connection.remotePeer.toB58String();
  pipe(stream, /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _value, _ret;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 2;

              _loop = function _loop() {
                var message = _value;
                var msg = void 0;

                try {
                  msg = JSON.parse(message.toString());
                } catch (err) {
                  emitter.emit('warning', err.message);
                  return "continue"; // early
                }

                if (peerId !== msg.from.toString()) {
                  emitter.emit('warning', 'no peerid match ' + msg.from);
                  return "continue"; // early
                }

                var topicIDs = msg.topicIDs;

                if (!Array.isArray(topicIDs)) {
                  emitter.emit('warning', 'no topic IDs');
                  return "continue"; // early
                }

                msg.data = Buffer.from(msg.data, 'hex');
                msg.seqno = Buffer.from(msg.seqno, 'hex');
                topicIDs.forEach(function (topic) {
                  emitter.emit(topic, msg);
                });
              };

              _iterator = _asyncIterator(source);

            case 5:
              _context.next = 7;
              return _iterator.next();

            case 7:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 11;
              return _step.value;

            case 11:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 19;
                break;
              }

              _ret = _loop();

              if (!(_ret === "continue")) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("continue", 16);

            case 16:
              _iteratorNormalCompletion = true;
              _context.next = 5;
              break;

            case 19:
              _context.next = 25;
              break;

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](2);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 25:
              _context.prev = 25;
              _context.prev = 26;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 30;
                break;
              }

              _context.next = 30;
              return _iterator.return();

            case 30:
              _context.prev = 30;

              if (!_didIteratorError) {
                _context.next = 33;
                break;
              }

              throw _iteratorError;

            case 33:
              return _context.finish(30);

            case 34:
              return _context.finish(25);

            case 35:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 21, 25, 35], [26,, 30, 34]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
}

exports = module.exports = {
  handler: handler,
  emitter: emitter
};